const ar = {
  // Navigation
  nav: {
    dashboard: 'لوحة التحكم',
    clients: 'الحرفاء',
    articles: 'المواد',
    documents: 'الوثائق',
    factures: 'الفواتير',
    devis: 'عروض الأسعار',
    avoirs: 'إشعارات الدائن',
    bonsLivraison: 'وصولات التسليم',
    paiements: 'المدفوعات',
    rapports: 'التقارير',
    rapportTva: 'تصريح الأداء على القيمة المضافة',
    etatAnnuel: 'الحالة السنوية',
    parametres: 'الإعدادات',
    societe: 'الشركة',
  },

  // Common
  common: {
    actions: 'إجراءات',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    print: 'طباعة',
    close: 'إغلاق',
    confirm: 'تأكيد',
    yes: 'نعم',
    no: 'لا',
    all: 'الكل',
    active: 'نشط',
    inactive: 'غير نشط',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    noResults: 'لا توجد نتائج',
    page: 'صفحة',
    of: 'من',
    rows: 'سطور',
    showing: 'عرض',
    to: 'إلى',
    total: 'المجموع',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    required: 'إجباري',
    optional: 'اختياري',
    status: 'الحالة',
    date: 'التاريخ',
    amount: 'المبلغ',
    description: 'الوصف',
    notes: 'ملاحظات',
    code: 'الرمز',
    designation: 'التسمية',
    reference: 'المرجع',
    telephone: 'الهاتف',
    email: 'البريد الإلكتروني',
    adresse: 'العنوان',
    ville: 'المدينة',
    codePostal: 'الرمز البريدي',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التعديل',
  },

  // Dashboard
  dashboard: {
    title: 'لوحة التحكم',
    caMensuel: 'رقم المعاملات الشهري',
    caAnnuel: 'رقم المعاملات السنوي',
    facturesImpayees: 'الفواتير غير المدفوعة',
    nombreClients: 'عدد الحرفاء',
    caMensuel12Mois: 'رقم المعاملات الشهري',
    topClients: 'أفضل 5 حرفاء حسب رقم المعاملات',
    dernieresFactures: 'آخر الفواتير',
    montant: 'المبلغ',
    client: 'الحريف',
    nombreFactures: 'عدد الفواتير',
  },

  // Clients
  clients: {
    title: 'الحرفاء',
    newClient: 'حريف جديد',
    editClient: 'تعديل الحريف',
    raisonSociale: 'الاسم التجاري',
    matriculeFiscal: 'المعرف الجبائي',
    categorie: 'الصنف',
    contact: 'الاتصال',
    contactNom: 'اسم جهة الاتصال',
    mobile: 'الجوال',
    fax: 'الفاكس',
    rib: 'التعريف البنكي',
    banque: 'البنك',
    plafondCredit: 'سقف الائتمان',
    delaiPaiement: 'أجل الدفع (أيام)',
    exonere: 'معفى من الأداء على القيمة المضافة',
    tauxRetenueSource: 'نسبة الخصم من المورد (%)',
    actif: 'حريف نشط',
    deleteConfirm: 'هل أنت متأكد من حذف هذا الحريف؟',
    matriculeFormat: 'الصيغة: 7 أرقام / حرف / حرف / حرف / 3 أرقام',
  },

  // Articles
  articles: {
    title: 'المواد',
    newArticle: 'مادة جديدة',
    editArticle: 'تعديل المادة',
    prixUnitaireHT: 'السعر الوحدوي خارج الأداء',
    tauxTva: 'نسبة الأداء على القيمة المضافة',
    unite: 'الوحدة',
    fodec: 'خاضع لمعلوم FODEC',
    categorie: 'الصنف',
    codeBarres: 'رمز الشريط',
    stockActuel: 'المخزون الحالي',
    stockMinimum: 'المخزون الأدنى',
    actif: 'مادة نشطة',
    deleteConfirm: 'هل أنت متأكد من حذف هذه المادة؟',
  },

  // Documents
  documents: {
    title: 'الوثائق',
    newDocument: 'وثيقة جديدة',
    editDocument: 'تعديل الوثيقة',
    detailDocument: 'تفاصيل الوثيقة',
    numero: 'الرقم',
    typeDocument: 'نوع الوثيقة',
    dateDocument: 'تاريخ الوثيقة',
    dateEcheance: 'تاريخ الاستحقاق',
    client: 'الحريف',
    selectClient: 'اختيار حريف',
    selectArticle: 'اختيار مادة',
    lignes: 'سطور الوثيقة',
    addLine: 'إضافة سطر',
    removeLine: 'حذف السطر',
    article: 'المادة',
    quantite: 'الكمية',
    prixUnitaire: 'السعر الوحدوي',
    remise: 'التخفيض (%)',
    montantHT: 'المبلغ خارج الأداء',
    montantFodec: 'FODEC',
    montantTva: 'مبلغ الأداء',
    tauxTva: 'نسبة الأداء',
    remiseTotale: 'مجموع التخفيض',
    totalHT: 'المجموع خارج الأداء',
    totalTva: 'مجموع الأداء',
    totalFodec: 'مجموع FODEC',
    timbreFiscal: 'معلوم الطابع الجبائي',
    timbreFiscalToggle: 'تطبيق معلوم الطابع الجبائي',
    timbreFiscalNonApplique: 'غير مطبق',
    totalTTC: 'المجموع بكل الأداءات',
    retenueSource: 'الخصم من المورد',
    netAPayer: 'الصافي للدفع',
    modePaiement: 'طريقة الدفع',
    statutPaiement: 'حالة الدفع',
    montantPaye: 'المبلغ المدفوع',
    resteAPayer: 'الباقي للدفع',
    referenceExterne: 'مرجع خارجي',
    convertToFacture: 'تحويل إلى فاتورة',
    convertConfirm: 'هل تريد تحويل عرض السعر إلى فاتورة؟',
    recordPayment: 'تسجيل دفع',
    paymentHistory: 'تاريخ المدفوعات',
    deleteConfirm: 'هل أنت متأكد من حذف هذه الوثيقة؟',
    printDocument: 'طباعة الوثيقة',
    eInvoiceToggle: 'الفوترة الإلكترونية (الفاتورة / TTN)',
    eInvoiceToggleHint: 'إنشاء ونقل الفاتورة بصيغة TEIF إلى منصة تونس للتجارة الإلكترونية. يُوضع الإمضاء المؤهل للوكالة الوطنية قبل الإرسال.',
    timbreFiscalToggleHint: 'ألغِ التحديد في العمليات المعفاة (التصدير، حريف غير مقيم، الامتياز الجبائي). عندئذ لا يُضاف الطابع إلى المبلغ الصافي ولا يُطبع على ملف PDF.',
    eInvoiceTitle: 'الفاتورة الإلكترونية — الفاتورة',
    eInvoiceSubtitle: 'إنشاء XML TEIF والإرسال إلى منصة TTN.',
    eInvoiceReference: 'مرجع TTN',
    eInvoiceTransmittedAt: 'أُرسلت في',
    eInvoiceMessage: 'رسالة TTN',
    eInvoiceGenerate: 'إنشاء XML TEIF',
    eInvoiceSubmit: 'إرسال إلى TTN',
    eInvoiceShowXml: 'عرض XML',
    eInvoiceHideXml: 'إخفاء XML',
    eInvoiceGenerated: 'تم إنشاء XML TEIF.',
    eInvoiceSubmitted: 'تم الإرسال إلى TTN.',
    eInvoiceError: 'خطأ في عملية TTN.',
    eInvoiceStatuts: {
      BROUILLON: 'مسودة',
      GENEREE: 'تم إنشاء XML',
      TRANSMISE: 'مُرسلة',
      ACCEPTEE: 'مقبولة من TTN',
      REJETEE: 'مرفوضة من TTN',
    },
  },

  // Paiements
  paiements: {
    title: 'المدفوعات',
    newPaiement: 'دفع جديد',
    datePaiement: 'تاريخ الدفع',
    montant: 'المبلغ',
    modePaiement: 'طريقة الدفع',
    reference: 'المرجع',
    banque: 'البنك',
    dateEcheance: 'تاريخ الاستحقاق',
    document: 'الوثيقة',
    deleteConfirm: 'هل أنت متأكد من حذف هذا الدفع؟',
  },

  // Rapports
  rapports: {
    title: 'التقارير',
    tva: {
      title: 'تصريح الأداء على القيمة المضافة',
      periode: 'الفترة',
      mois: 'الشهر',
      annee: 'السنة',
      generer: 'إنشاء',
      baseHT: 'الأساس خارج الأداء',
      tvaCollectee: 'الأداء المحصل',
      tva7: 'أداء 7%',
      tva13: 'أداء 13%',
      tva19: 'أداء 19%',
      totalTva: 'مجموع الأداء',
      fodec: 'FODEC',
      timbre: 'معلوم الطابع',
    },
    annuel: {
      title: 'الحالة السنوية',
      annee: 'السنة',
      caTotal: 'رقم المعاملات الإجمالي',
      tvaCollectee: 'الأداء المحصل',
      nombreFactures: 'عدد الفواتير',
      nombreDevis: 'عدد عروض الأسعار',
      nombreAvoirs: 'عدد إشعارات الدائن',
      repartitionTva: 'التوزيع حسب نسبة الأداء',
      evolutionCA: 'تطور رقم المعاملات',
    },
  },

  // Paramètres
  parametres: {
    title: 'الإعدادات',
    societe: {
      title: 'إعدادات الشركة',
      raisonSociale: 'الاسم التجاري',
      matriculeFiscal: 'المعرف الجبائي',
      adresse: 'العنوان',
      codePostal: 'الرمز البريدي',
      ville: 'المدينة',
      telephone: 'الهاتف',
      email: 'البريد الإلكتروني',
      siteWeb: 'الموقع الإلكتروني',
      rib: 'التعريف البنكي',
      banque: 'البنك',
      logo: 'الشعار',
      uploadLogo: 'تحميل الشعار',
      timbreFiscal: 'مبلغ الطابع الجبائي (د.ت)',
      tauxFodec: 'نسبة FODEC (%)',
    },
  },

  // Validation messages
  validation: {
    required: 'هذا الحقل إجباري',
    email: 'عنوان بريد إلكتروني غير صالح',
    phone: 'رقم هاتف غير صالح',
    matriculeFiscal: 'معرف جبائي غير صالح (الصيغة: 1234567/أ/ب/ت/123)',
    rib: 'تعريف بنكي غير صالح (20 رقم)',
    codePostal: 'رمز بريدي غير صالح (4 أرقام)',
    positiveNumber: 'يجب أن تكون القيمة إيجابية',
    minLength: 'الحد الأدنى {min} حرف',
  },

  // Messages
  messages: {
    saveSuccess: 'تم الحفظ بنجاح',
    saveError: 'خطأ أثناء الحفظ',
    deleteSuccess: 'تم الحذف بنجاح',
    deleteError: 'خطأ أثناء الحذف',
    loadError: 'خطأ أثناء تحميل البيانات',
    convertSuccess: 'تم تحويل عرض السعر إلى فاتورة بنجاح',
    paymentSuccess: 'تم تسجيل الدفع بنجاح',
    confirmDelete: 'تأكيد الحذف',
    confirmDeleteMessage: 'هذا الإجراء لا رجعة فيه. هل تريد المتابعة؟',
  },

  // Months
  months: [
    'جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان',
    'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر',
  ],

  // Admin (platform administration console)
  admin: {
    console: 'الإدارة',
    logout: 'تسجيل الخروج',
    nav: {
      dashboard: 'لوحة القيادة',
      subscribers: 'المشتركون',
      invoices: 'فواتير SaaS',
      metrics: 'المقاييس',
      aiModels: 'نماذج الذكاء الاصطناعي',
      ops: 'العمليات',
    },
    dashboard: {
      title: 'لوحة قيادة الإدارة',
      subtitle: 'نظرة عامة على منصة GreenBill.',
      totalSubscribers: 'المشتركون النشطون',
      mrr: 'الإيرادات الشهرية المتكررة',
      pendingInvoices: 'فواتير في الانتظار',
      planChanges: 'تغييرات الخطة (30 يومًا)',
      byPlan: 'التوزيع حسب الخطة',
      viewAll: '← عرض كل المشتركين',
    },
    subscribers: {
      title: 'المشتركون',
      searchPlaceholder: 'الاسم التجاري، المعرف الجبائي، البريد الإلكتروني…',
      allPlans: 'كل الخطط',
      col: {
        name: 'الاسم التجاري',
        mf: 'المعرف الجبائي',
        plan: 'الخطة',
        invoicesMonth: 'الفواتير (الشهر)',
        users: 'المستخدمون',
        createdAt: 'تاريخ التسجيل',
      },
    },
    subscriberDetail: {
      back: 'العودة إلى القائمة',
      createdAt: 'تاريخ التسجيل',
      plan: 'الخطة الحالية',
      users: 'مستخدم(ون)',
      reasonPrompt: 'سبب تغيير الخطة؟',
      planUpdated: 'تم تحديث الخطة',
      usageTitle: 'الاستخدام',
      invoicesTitle: 'فواتير SaaS',
      noInvoices: 'لا توجد فواتير SaaS لهذا المشترك.',
      period: 'الفترة',
      amount: 'المبلغ مع الضريبة',
    },
    usage: {
      invoices: 'الفواتير المنشأة',
      ocr: 'صفحات OCR',
      api: 'استدعاءات API',
      seats: 'مقاعد المستخدمين',
      documents: 'وثائق (أخرى)',
    },
    invoices: {
      title: 'فواتير SaaS',
      allStatuses: 'كل الحالات',
      runBilling: 'تشغيل الفوترة الشهرية',
      runConfirm: 'إنشاء فواتير SaaS للشهر الحالي؟',
      invoicesCreated: 'فواتير منشأة',
      openLink: 'فتح',
      col: {
        company: 'المشترك',
        period: 'الفترة',
        amount: 'مع الضريبة',
        payment: 'رابط الدفع',
      },
    },
    metrics: {
      title: 'مقاييس SaaS',
      mrr: 'MRR (د.ت)',
      arr: 'ARR (د.ت)',
      totalSubscribers: 'المشتركون النشطون',
      byPlan: 'المشتركون حسب الخطة',
      paidThisMonth: 'فواتير مدفوعة',
      pendingThisMonth: 'فواتير في الانتظار',
      planChanges: 'تغييرات الخطة (30 يومًا)',
    },
    ops: {
      title: 'العمليات',
      subtitle: 'سجلات الخادم وحالة النظام والمهام المجدولة.',
      tabs: {
        logs: 'الطرفية',
        system: 'النظام',
        health: 'الصحة',
        gts: 'Green Target',
        jobs: 'المهام',
      },
      logs: {
        title: 'طرفية الخادم',
        level: 'المستوى',
        allLevels: 'كل المستويات',
        search: 'البحث في السجلات…',
        lines: 'الأسطر',
        autoRefresh: 'تحديث تلقائي',
        refresh: 'تحديث',
        download: 'تنزيل',
        empty: 'لا توجد أسطر سجل.',
        unavailable: 'ملف السجل غير موجود على الخادم.',
        returned: 'أسطر',
      },
      system: {
        title: 'النظام',
        appName: 'التطبيق',
        profiles: 'الملفات النشطة',
        uptime: 'مدة التشغيل',
        startedAt: 'بدأ في',
        java: 'إصدار Java',
        os: 'نظام التشغيل',
        processors: 'المعالجات',
        threads: 'الخيوط',
        heap: 'الذاكرة (heap)',
      },
      health: {
        title: 'الصحة',
        status: 'الحالة العامة',
        components: 'المكونات',
      },
      gts: {
        title: 'Green Target',
        verdictOk: 'المزامنة مع Green Target تعمل بشكل سليم',
        verdictWarn: 'مُهيّأ، لكن يتطلب الانتباه',
        verdictKo: 'غير مُهيّأ أو غير قابل للوصول',
        refresh: 'تحديث',
        sync: 'مزامنة',
        syncing: 'جارٍ المزامنة…',
        syncDone: 'تمت المزامنة',
        backfilledLabel: 'مُضافة',
        publishedNowLabel: 'منشورة',
        syncDisabledHint: 'جسر REST معطّل',
        configTitle: 'الإعدادات',
        bridgeEnabled: 'جسر REST مفعّل',
        ssoConfigured: 'سر SSO المشترك مُهيّأ',
        kafkaEnabled: 'نقل Kafka',
        gtsBaseUrl: 'عنوان واجهة GTS',
        gtsSsoBaseUrl: 'عنوان SSO لـ GTS',
        connTitle: 'الاتصال',
        reachable: 'GTS قابل للوصول',
        latency: 'زمن الاستجابة',
        httpStatus: 'حالة HTTP',
        syncTitle: 'طابور المزامنة (outbox)',
        pending: 'قيد الانتظار',
        published: 'منشورة',
        failed: 'فاشلة',
        lastPublished: 'آخر مزامنة ناجحة',
        oldestPending: 'أقدم حدث قيد الانتظار',
        yes: 'نعم',
        no: 'لا',
        active: 'نشط',
        off: 'معطّل',
        never: 'أبداً',
      },
      jobs: {
        title: 'المهام المجدولة',
        schedule: 'الجدولة',
        nextRun: 'التشغيل التالي',
        enabled: 'مفعّلة',
        disabled: 'معطّلة',
        run: 'تشغيل',
        running: 'جارٍ…',
        triggered: 'تم تشغيل المهمة',
        confirm: 'تشغيل هذه المهمة الآن؟',
      },
    },
    aiModels: {
      title: 'نماذج الذكاء الاصطناعي',
      subtitle:
        'عدّل المزوّد والنموذج المستخدم لكل ميزة ذكاء اصطناعي. اختبر قبل الحفظ.',
      refresh: 'تحديث',
      disabledWarning:
        'الذكاء الاصطناعي معطّل عالميًا (app.llm.enabled=false). يتم حفظ التغييرات لكنها لا تُستخدم حتى إعادة التفعيل.',
      notConfigured: 'غير مهيأ',
      provider: 'المزوّد',
      model: 'النموذج',
      temperature: 'الحرارة',
      maxTokens: 'أقصى عدد للرموز',
      jsonMode: 'وضع JSON',
      test: 'اختبار',
      testing: 'جارٍ الاختبار…',
      testOk: 'نجح الاختبار',
      testFailed: 'فشل الاختبار',
      testFirst: 'اختبر بنجاح قبل الحفظ',
      save: 'حفظ',
      saving: 'جارٍ الحفظ…',
      saved: 'تم حفظ النموذج',
      unsaved: 'غير محفوظ',
      modelRequired: 'النموذج مطلوب.',
      loadingModels: 'جارٍ تحميل النماذج…',
      noModels: 'لا توجد نماذج متاحة. أدخل المعرّف يدويًا.',
      noMatch: 'لا يوجد نموذج مطابق.',
      moreModels: 'حسّن بحثك لعرض المزيد من النماذج…',
      free: 'مجاني',
      vision: 'رؤية',
      tokens: 'رمز',
      priceLabel: 'السعر (إدخال/إخراج لكل 1M رمز)',
      priceHint: 'الأسعار بالدولار لكل مليون رمز (إدخال / إخراج).',
      features: {
        OCR: 'OCR (قراءة الفواتير)',
        RELANCE_EMAIL: 'تذكيرات بالبريد',
        DASHBOARD_ASSISTANT: 'مساعد لوحة القيادة',
      },
    },
  },
};

export default ar;
